import { useEffect, useState } from 'react';
import { Button, FloatingLabel, Form, Modal } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { PutAnalysisJustification } from '../../../API/AnalysisAPI';
import { IResponseProps } from '../../../Interfaces/IResponseProps';

interface IModalIsFinanciableComponentProps {
    show: boolean,
    observation: string,
    toggleShow: () => void,
    setObservation: React.Dispatch<React.SetStateAction<string>>,
    setSendInfos: React.Dispatch<React.SetStateAction<boolean>>,
    toggleLoading: (data: boolean) => void,
    setValueHasChanged: React.Dispatch<React.SetStateAction<boolean>>,
    analysisId: string,
    userEmail: string,
    companyId: string,
    financialValue: number,
    potentialValue: number,
    hasConcluded: boolean
}

const ModalIsFinanciableComponent = (props: IModalIsFinanciableComponentProps) => {
    const [text, setText] = useState<string>("");

    const handleClose = () => {
        props.setSendInfos(false);
        props.toggleShow();
    }

    const handleCloseWithResponse = () => {
        props.setSendInfos(true);
        props.toggleShow();
    }

    const deleteObservation = async () => {
        try {
            props.toggleLoading(true);
            
            props.setObservation("");
            await PutAnalysisJustification(props.analysisId, "", props.userEmail, props.companyId).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    props.setValueHasChanged(true);
                    handleClose();
                }
            }).finally(() => props.toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    const getTextObservation = () => {
        var defaultText = "";
        if (props.financialValue > props.potentialValue) {
            let value = new Intl.NumberFormat("pt-BR", {
                minimumFractionDigits: 2,
            }).format(props.financialValue - props.potentialValue);

            defaultText = `Não será possível alcançar o valor pretendido pela empresa, pois existem indicadores que limitam o valor potencial a ser financiado, ver o campo de observações adicionais. O valor pretendido deve ser reduzido em R$ ${value}.`;
        } else if (props.financialValue > props.potentialValue) {
            let value = new Intl.NumberFormat("pt-BR", {
                minimumFractionDigits: 2,
            }).format(props.potentialValue - props.financialValue);

            defaultText = `Conforme resultado alcançado nos indicadores financeiros, a empresa poderá realizar uma captação de recursos maior do que o valor pretendido inicialmente. Existe espaço para solicitar mais R$ ${value}.`;
        }

        setText(defaultText);
    }

    useEffect(() => {
        if(props.show) {
            getTextObservation();
        }
    }, [props.show]);

    return (
        <Modal size="lg" show={props.show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Mudar status de análise</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.financialValue != props.potentialValue &&
                    <div>
                        <label>Observação: </label>
                        <FloatingLabel label="" className="mb-3">
                            <Form.Control disabled as="textarea" id="input-text-area" value={text} />
                        </FloatingLabel>
                    </div>
                }
                <div>
                    <label className='required'>Observação Adicional: </label>
                    <FloatingLabel label="" className="mb-3">
                        <Form.Control disabled={props.hasConcluded} required as="textarea" id="input-text-area" value={props.observation} onChange={(e: any) => props.setObservation(e.target.value)} />
                    </FloatingLabel>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className='d-flex align-items-center text-nowrap justify-content-start w-100'>
                    <Button className='btn btn-primary w-100 me-2' onClick={handleCloseWithResponse}>
                        Salvar
                    </Button>
                    <Button className='btn btn-secondary w-25 ms-2' onClick={deleteObservation}>
                        <FaTrash className='white-icon' />
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalIsFinanciableComponent;